// @ts-nocheck
import state from "../state/main"

export default () => {
  state.AJAX_REQUEST_CACHE = {}
}
